import { StackScreenProps } from "@react-navigation/stack";
import { useCallback } from "react";
import { Colors, View } from "react-native-ui-lib";
import { Page } from "@towersystems/roam-common-native";
import { Button } from "@towersystems/roam-common-native";
import {
  CheckoutRootParamList,
  PaymentRootScreenParamList,
  RegisterRootParamList,
} from "../../../../types";
import PaymentMethod from "../../../../utilities/data/model/PaymentMethod";
import { moneyToFormattedString } from "../../../../utilities/money";
import { useCheckoutContextProvider } from "../../utils/checkout";
import { usePaymentControllerProvider } from "../../utils/payment-controller";
import { Text } from "@towersystems/roam-common-native";
import React from "react";
import {
  usePaymentActionsContextProvider,
  usePaymentRootScreenContextProvider,
} from "../PaymentRootScreen/hooks";
import { OnAfterPaymentFn } from "../PaymentRootScreen/context";

export type GiveChangeBackScreenProps = StackScreenProps<
  PaymentRootScreenParamList & RegisterRootParamList & CheckoutRootParamList,
  "GiveChangeBackScreen"
>;

export const GiveChangeBackScreen = ({
  navigation,
  route,
}: GiveChangeBackScreenProps) => {
  const paymentRootContext = usePaymentRootScreenContextProvider();

  const maybeParentScreenContext = usePaymentActionsContextProvider();
  const { sale } = useCheckoutContextProvider();
  const { addPayment } = usePaymentControllerProvider();

  const paymentMethod = paymentRootContext.paymentMethod;
  const changeAmount = route.params.changeAmount;
  const paymentAmount = route.params.paymentAmount;

  const handleOnAfterPayment: OnAfterPaymentFn = React.useCallback(
    async (canClose) => {
      /**
       * One last chance to modify the sale (or to highjack the navigation), for example,
       * converting the sale to a LayBy, Invoice or Quote
       *
       * returning false here will prevent the screen from closing,
       * and it is up to the implementer to close the screen
       */
      if (maybeParentScreenContext?.onAfterPayment) {
        const result = await maybeParentScreenContext?.onAfterPayment(canClose);
        if (result === false) {
          return;
        }
      }
      if (false === canClose) {
        /**
         * If the sale can't be closed, we should
         * navigate back to the payment method selection screen.
         *
         * By default this will navigation back to the parent screen
         */

        navigation.getParent()?.goBack();
      } else {
        navigation.reset({
          index: 0,
          routes: [{ name: "CheckoutSummaryRootScreen" }],
        });
      }
    },
    [maybeParentScreenContext]
  );

  const handleOnAddPayment = useCallback(async () => {
    await addPayment(paymentMethod, { tenderedAmount: paymentAmount });
    const canClose = await sale.canTransitionToClosed_ASYNC();
    await handleOnAfterPayment(canClose);
  }, [paymentMethod.id, paymentAmount, sale]);

  const footerMarkup = (
    <View>
      <Button
        fullWidth
        style={{}}
        onPress={handleOnAddPayment}
        backgroundColor={Colors.primary}
      >
        <Text style={{ color: Colors.white, fontSize: 22, fontWeight: "bold" }}>
          {`Give back ${moneyToFormattedString(changeAmount)}`}
        </Text>
      </Button>
    </View>
  );

  return (
    <Page footer={footerMarkup}>
      <View></View>
    </Page>
  );
};
